<template>
  <div id="fh5co-wrapper">
    <div id="fh5co-page">
      <Header></Header>
      <div class="signin-container text-center">
        <h2>会員専用ログイン</h2>
        <input type="text" placeholder="※STORES.jpで登録したメールアドレスを入力してください" v-model="username" />
        <input type="password" placeholder="パスワード" v-model="password" />
        <button @click="signIn" class="btn btn-border btn-border-round">ログイン</button>
        <a href="/signup" class="signin-signup-link">パスワード設定がお済みでない方はこちら</a>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import Header from './Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'Signin',
  data: function () {
    return {
      username: '',
      password: ''
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    signIn: function () {
      firebase.auth().signInWithEmailAndPassword(this.username, this.password).then(
        user => {
          this.$router.push('/menu')
        },
        err => {
          alert(err.message)
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.signin-container {
  margin: 20px auto 40px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
input {
  margin: 10px 0;
  padding: 10px;
  border: 3px #ccc solid;
  width: 90%;
  max-width: 500px;
}

.signin-signup-link{
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/Signin.vue